var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 10376"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 422",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#FF6187"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M10.3231 4.67704C10.0869 4.44099 9.70412 4.44099 9.46799 4.67704L7.48567 6.65927L5.53221 4.70574C5.29608 4.46969 4.91331 4.46969 4.6771 4.70574C4.44097 4.94195 4.44097 5.32472 4.6771 5.56085L6.63055 7.51431L4.7058 9.43907C4.46967 9.67528 4.46967 10.0581 4.7058 10.2942C4.8239 10.4122 4.97861 10.4712 5.1334 10.4712C5.2881 10.4712 5.44289 10.4122 5.56099 10.2942L7.48567 8.36951L9.43913 10.323C9.55723 10.441 9.71194 10.5 9.86672 10.5C10.0214 10.5 10.1762 10.441 10.2943 10.323C10.5305 10.0868 10.5305 9.70398 10.2943 9.46785L8.34087 7.51439L10.3231 5.53215C10.5592 5.29594 10.5592 4.91317 10.3231 4.67704Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/Failed.9276bf40a1cc05d81164175efc33bec8.svg";
export { ForwardRef as ReactComponent };